import { Fragment } from "react/jsx-runtime";
import { useCustomDrop } from "../planning/horizontalCalendarElements/CustomDragContext";

export default function HorizontalDay({ date, isOutside, style, isHoliday }) {
  const { isDragging, element } = useCustomDrop({ date });
  return (
    <Fragment>
      {isDragging ? <div {...element} className={"hc-droptarget"} style={style} /> : null}
      <div className={"hc-day" + (isOutside ? " outside" : "") + (isHoliday ? " holiday" : "")} style={style} />
    </Fragment>
  );
}
